/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Selected_ContentInputs */

const en_subscription_selected_content = /** @type {(inputs: Subscription_Selected_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seasonal Select Crystal Trees`)
};

const ar_subscription_selected_content = /** @type {(inputs: Subscription_Selected_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أشجار كريستالية موسمية مختارة`)
};

const de_subscription_selected_content = /** @type {(inputs: Subscription_Selected_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisonal ausgewählte Kristallbäume`)
};

const es_subscription_selected_content = /** @type {(inputs: Subscription_Selected_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Árboles de cristal de temporada seleccionados`)
};

const fr_subscription_selected_content = /** @type {(inputs: Subscription_Selected_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arbres premium de saison`)
};

const it_subscription_selected_content = /** @type {(inputs: Subscription_Selected_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selezione stagionale degli alberi di cristalli`)
};

const ja_subscription_selected_content = /** @type {(inputs: Subscription_Selected_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シーズン限定クリスタルツリー`)
};

const ko_subscription_selected_content = /** @type {(inputs: Subscription_Selected_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시즌별 엄선된 크리스탈 나무`)
};

const pt_br_subscription_selected_content = /** @type {(inputs: Subscription_Selected_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Árvores sazonais de Cristais do Tempo`)
};

const ru_subscription_selected_content = /** @type {(inputs: Subscription_Selected_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сезонные кристальные деревья на выбор`)
};

const th_subscription_selected_content = /** @type {(inputs: Subscription_Selected_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต้นไม้คริสตัลที่คัดสรรตามฤดูกาล`)
};

const tr_subscription_selected_content = /** @type {(inputs: Subscription_Selected_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mevsimsel Seçkin Kristal Ağaçlar`)
};

const zh_cn_subscription_selected_content = /** @type {(inputs: Subscription_Selected_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当季精选宝石树种`)
};

const zh_tw_subscription_selected_content = /** @type {(inputs: Subscription_Selected_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`當季精選寶石樹種`)
};

/**
* | output |
* | --- |
* | "Seasonal Select Crystal Trees" |
*
* @param {Subscription_Selected_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_selected_content = /** @type {((inputs?: Subscription_Selected_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Selected_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_selected_content(inputs)
	if (locale === "ar") return ar_subscription_selected_content(inputs)
	if (locale === "de") return de_subscription_selected_content(inputs)
	if (locale === "es") return es_subscription_selected_content(inputs)
	if (locale === "fr") return fr_subscription_selected_content(inputs)
	if (locale === "it") return it_subscription_selected_content(inputs)
	if (locale === "ja") return ja_subscription_selected_content(inputs)
	if (locale === "ko") return ko_subscription_selected_content(inputs)
	if (locale === "pt_br") return pt_br_subscription_selected_content(inputs)
	if (locale === "ru") return ru_subscription_selected_content(inputs)
	if (locale === "th") return th_subscription_selected_content(inputs)
	if (locale === "tr") return tr_subscription_selected_content(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_selected_content(inputs)
	return zh_tw_subscription_selected_content(inputs)
});